import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { Column } from '@prisjakt/ui/list/variants';

export const FeedbackBox = styled.div`
  background: #f5fdff;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${layout.measurements.spacing200};
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Question = styled(Column)``;

export const ButtonContainer = styled.span`
  margin-top: ${layout.measurements.spacing100};
`;

type OptionProps = {
  selected?: boolean;
};

export const Button = styled.button<OptionProps>`
  border: 1px solid #00addb;
  background: none;
  box-sizing: border-box;
  color: #00addb;
  border-radius: 24px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s;
  &:hover {
    background: #00addb;
    color: #ffffff;
  }
  padding: ${layout.measurements.spacing100} ${layout.measurements.spacing150};
  margin: ${layout.measurements.spacing050} ${layout.measurements.spacing025};
`;
